<div
	class="notification-item bg-{{ notification.style }} rounded"
	[class.minimized]="isMinimized"
	(mouseenter)="onMouseEnter()"
	(mouseleave)="onMouseLeave()"
	role="alert"
>
	<div
		class="d-flex align-items-center justify-content-between p-3"
		[ngClass]="{
			'ps-2': isMinimized,
		}"
	>
		<div class="d-flex align-items-center flex-grow-1">
			<!-- Progress Indicator (Spinner, Progress Wheel, or Checkmark) - shown before icon -->
			<div
				class="progress-indicator me-2"
				*ngIf="hasProgressIndicator"
				[class.text-dark]="notification.style === 'warning'"
				[class.text-white]="notification.style !== 'warning'"
			>
				<div class="d-flex flex-column align-items-center">
					<!-- Show checkmark when progress reaches 100% -->
					<i
						*ngIf="notification.progress === 100"
						class="bi bi-check2 text-white fs-4"
						aria-hidden="true"
					></i>
					<!-- Show progress wheel for spinner (-2) or progress 0-99 -->
					<app-progress-wheel
						*ngIf="notification.progress !== 100"
						[progress]="notification.progress"
						style="transform: scale(1.15)"
					></app-progress-wheel>
					<!-- Truncated text shown below spinner when minimized -->
					<div
						*ngIf="isMinimized"
						class="minimized-text"
						[class.text-dark]="notification.style === 'warning'"
						[class.text-white]="notification.style !== 'warning'"
					>
						{{ truncatedMessage }}
					</div>
				</div>
			</div>

			<!-- Minimized text for notifications without progress indicator -->
			<div
				class="minimized-text-only me-2"
				*ngIf="isMinimized && !hasProgressIndicator"
				[class.text-dark]="notification.style === 'warning'"
				[class.text-white]="notification.style !== 'warning'"
			>
				{{ truncatedMessage }}
			</div>

			<!-- Icon -->
			<!-- <i
				class="bi {{ notification.icon }} text-white me-3 fs-4"
				aria-hidden="true"
			></i> -->

			<!-- Message -->
			<span
				[class]="
					notification.style === 'warning'
						? 'text-dark notification-message'
						: 'text-white notification-message'
				"
				>{{ notification.message }}</span
			>
		</div>

		<!-- Action Button -->
		<button
			*ngIf="notification.actionButton && !isMinimized"
			type="button"
			class="btn btn-outline-light btn-sm ms-2 text-nowrap"
			(click)="onActionButtonClick()"
		>
			{{ notification.actionButton.buttonText }}
			<i
				[class]="notification.actionButton.iconClass"
				*ngIf="notification.actionButton.iconClass"
			></i>
		</button>

		<!-- Close Button -->
		<button
			*ngIf="notification.showCloseButton"
			type="button"
			[class]="
				notification.style === 'warning'
					? 'btn-close ms-3'
					: 'btn-close btn-close-white ms-3'
			"
			aria-label="Close"
			(click)="onClose()"
		></button>
	</div>
</div>
